import {Nullish} from 'shared/web';

import {cataloguePlaceholders} from '../constants/cataloguePlaceholders';
import {VehicleMakeModelData} from '../types/VehicleMakeModelParsers';
import {sortByLabel} from './sortByLabel';

/** Model families a value can be set to, across the makes the catalogue was asked for. */
export function toSelectableModelFamilyOptions(catalogue: VehicleMakeModelData | Nullish) {
  return (
    sortByLabel(
      (catalogue ?? [])
        .flatMap((entry) => entry.models ?? [])
        .filter((model) => !model.model.endsWith(cataloguePlaceholders.modelFamilySuffix))
        .map((model) => ({value: model.model, label: model.default_label}))
    ) ?? []
  );
}
